import { Trans, useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import {
  formatEarningsAmount,
  formatEarningsPercentage,
  getEarningsHeadline,
} from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/helpers'

import { earningsHeadlineCopies, netSalesFractionDigits } from '../constants'
import { getEarningsPercentageColor, getEarningsWarningScenario, getTopMarginCosts } from '../helpers'
import EarningsTile from './EarningsTile/EarningsTile'
import EarningsWarning from './EarningsWarning/EarningsWarning'
import MarginInsight from './MarginInsight/MarginInsight'
import * as Styles from './styles'

const YourEarningsContent = ({ earnings }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const headline = getEarningsHeadline(earnings)
  const copies = earningsHeadlineCopies[headline.level]
  const amount = formatEarningsAmount(headline.amount, earnings.currency, i18n.language)
  const warningScenario = getEarningsWarningScenario(earnings)
  const topMarginCosts = getTopMarginCosts(earnings)

  return (
    <>
      <CardDescription>{t(copies.subtitle)}</CardDescription>
      <Styles.Body>
        {warningScenario && <EarningsWarning scenario={warningScenario} />}
        <Styles.Content>
          <Styles.Headline>
            <Text type="titleXXL" color={getEarningsPercentageColor(headline.percentage, theme)}>
              {formatEarningsPercentage(headline.percentage, i18n.language)}
            </Text>
            <Text type="bodyMRegular" color={theme.colors.text.muted}>
              <Trans i18nKey={copies.sublabel} values={{ amount }} components={{ bold: <strong /> }} />
            </Text>
          </Styles.Headline>
          <Styles.Tiles>
            <EarningsTile
              label={t('Margen de producto')}
              tooltip={t(
                '(Ventas netas − coste de producto) ÷ ventas netas. Antes de logística, devoluciones y aduanas.'
              )}
              value={formatEarningsPercentage(earnings.product_margin_percentage, i18n.language)}
            />
            <EarningsTile
              label={t('Ventas netas')}
              tooltip={t('Tus ventas sin IVA. Es la base sobre la que se calcula el margen.')}
              value={formatEarningsAmount(earnings.net_sales, earnings.currency, i18n.language, netSalesFractionDigits)}
            />
          </Styles.Tiles>
        </Styles.Content>
        {topMarginCosts.length > 0 && <MarginInsight marginCosts={topMarginCosts} />}
      </Styles.Body>
    </>
  )
}

export default YourEarningsContent
